import React from "react";
import { AlertTriangle, Info } from "lucide-react";
import { DISCLAIMER_MODULE, DISCLAIMER_OUTPUT } from "@/lib/disclaimer";

/** Amber banner shown at the top of high-stakes clinical modules. */
export function ClinicalBanner({ testid = "clinical-banner" }) {
  return (
    <div className="mb-5 px-4 py-2.5 rounded-md bg-amber-50 border border-amber-200 text-amber-900 flex items-center gap-2.5 text-[13px] leading-snug" data-testid={testid}>
      <AlertTriangle className="w-4 h-4 shrink-0 text-amber-700" />
      <span>{DISCLAIMER_MODULE}</span>
    </div>
  );
}

/** Inline text block shown above every AI-generated output (SOAP, letters, alerts, recommendations). */
export function AIOutputDisclaimer({ testid = "ai-output-disclaimer" }) {
  return (
    <div className="mb-3 px-3 py-2 rounded-md bg-amber-50 border-l-4 border-amber-500 text-amber-900 flex gap-2 text-xs leading-relaxed" data-testid={testid}>
      <Info className="w-3.5 h-3.5 shrink-0 mt-0.5 text-amber-700" />
      <span>{DISCLAIMER_OUTPUT}</span>
    </div>
  );
}

/** Persistent footer disclaimer bar shown across all authenticated pages. */
export function DisclaimerFooter() {
  return (
    <div className="border-t border-amber-200 bg-amber-50/60 px-6 py-2 text-[11px] text-amber-900 flex flex-col sm:flex-row items-center gap-1 sm:gap-3 justify-center text-center" data-testid="disclaimer-footer">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-3 h-3 text-amber-700 shrink-0" />
        <span>ZidaMD provides clinical decision support only. All clinical decisions are the sole responsibility of the licensed practitioner. Not FDA cleared. Not a substitute for professional clinical judgment.</span>
      </div>
      <span className="hidden sm:inline opacity-50">•</span>
      <span className="opacity-90">CamelionAI LLC — Boca Raton, FL • Patent Pending USPTO #64/078,696 | #64/078,734 | #64/062,147 • admin@zidamd.com</span>
    </div>
  );
}
